import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[agencyCoreNumberOnly]',
  standalone: true,
})
export class NumberOnlyDirective {
  @Input() allowDecimal = false;
  @Input() maxInt = 8;
  @Input() maxDecimal = 2;

  constructor(private ngControl: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const selectionStart = input.selectionStart ?? value.length;
    const selectionEnd = input.selectionEnd ?? value.length;

    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
    const ctrlCommands = event.ctrlKey || event.metaKey;

    if (allowedKeys.includes(event.key) || ctrlCommands) return;

    const isNumber = /^[0-9]$/.test(event.key);
    const isDot = event.key === '.';

    if (this.allowDecimal) {
      const alreadyHasDot = value.includes('.');
      if (!isNumber && (!isDot || alreadyHasDot)) {
        event.preventDefault();
        return;
      }

      // Predict new value
      const newValue = value.slice(0, selectionStart) + event.key + value.slice(selectionEnd);
      const [intPart, decPart = ''] = newValue.split('.');
      if (intPart.length > this.maxInt || decPart.length > this.maxDecimal) {
        event.preventDefault();
      }

    } else {
      if (!isNumber) {
        event.preventDefault();
        return;
      }

      const newValue = value.slice(0, selectionStart) + event.key + value.slice(selectionEnd);
      if (newValue.length > this.maxInt) {
        event.preventDefault();
      }
    }
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let cleaned = input.value;

    if (this.allowDecimal) {
      cleaned = cleaned.replace(/[^0-9.]/g, '');

      const parts = cleaned.split('.');
      const intPart = parts[0].slice(0, this.maxInt);
      const decPart = parts[1]?.replace(/\./g, '').slice(0, this.maxDecimal) || '';

      cleaned = this.maxDecimal > 0 && decPart ? `${intPart}.${decPart}` : intPart;
    } else {
      cleaned = cleaned.replace(/[^0-9]/g, '').slice(0, this.maxInt);
    }

    if (input.value !== cleaned) {
      input.value = cleaned;
      this.ngControl.control?.setValue(cleaned);
    }
  }
}
